<template>
  <div class="card" v-if="lieuDeLivraison">
    <header class="header-card">
        <p>
        {{ $t('detailOrdreTravailTech.lieuDeLivraison.generalInformations')}}
        </p>
    </header>
    <div class="card-content">
        <div class="columns is-multiline column is-12">
            <b-field
                class="column is-6"
                :label="$t('detailOrdreTravailTech.lieuDeLivraison.raisonSociale')"
                custom-class="has-text-link">
              <router-link-blank v-if="lieuDeLivraison"
                classMessage="has-text-weight-bold lien mgr-5px"
                v-bind="getRoute()"/>
            </b-field>
            <div class="column is-5">
                <p class="has-text-default is-italic" v-if="adresse">
                    {{$t('detailOrdreTravailTech.lieuDeLivraison.adresse')}}</p>
                <p class="has-text-default has-text-weight-semibold">
                    {{adresse.intitule1}}
                    {{adresse.intitule2}}
                    {{adresse.intitule3}}
                    <br v-if="adresse.intitule1">
                    {{adresse.adresse1}}
                    {{adresse.adresse2}}
                    {{adresse.adresse3}}
                    <br v-if="adresse.adresse1">
                    {{adresse.codePostal}}
                    {{adresse.ville}}
                    {{adresse.pays}}
                    <span v-if="adresse.departement">
                        <br/>{{ $t('detailOrdreTravailTech.lieuDeLivraison.dept') }} : </span>
                    {{ adresse.departement }}
                </p>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { TIERS_TYPE_CLIENT } from '@/configuration/tiers/tiersConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ordreTravail: {
      type: Object,
      require: false,
    },
  },
  data() {
    return {
      lieuDeLivraison: null,
      lieuDeLivraisonId: null,
    };
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    adresse() {
      return this.lieuDeLivraison.adresse ?? this.lieuDeLivraison.adressePostale;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getRoute() {
      const route = {
        to: {
          name: 'c.achat.lieu_de_livraison',
          params: {
            id: this.lieuDeLivraisonId,
          },
        },
        message: this.lieuDeLivraison.nomCommercial ?? '',
      };
      if (this.lieuDeLivraison.type === TIERS_TYPE_CLIENT) {
        route.to = {
          name: 'c.bodac.clients/contacts-client',
          params: {
            id: this.lieuDeLivraisonId,
          },
        };
      }
      return route;
    },
  },
  async mounted() {
    await this.loadParametresInterne([
      PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
      PARAMETRES_INTERNE_KEYS.demandeImpression.key,
    ]);
    this.lieuDeLivraison = this.ordreTravail.otStock?.lieuDeLivraison
      ?? this.ordreTravail.otStock?.lieuDeStockage;

    this.lieuDeLivraisonId = this.ordreTravail?.otStock?.lieuDeLivraisonId
      ?? this.ordreTravail?.otStock?.lieuDeStockageId;
  },
};
</script>
